import type {
    IServiceClientFilterValues,
    ServiceClientSearchQuery,
    TFiltersOptions,
} from './types';

/**
 * Builds the search query from current filters and access-level options.
 * Sets 1-based page, limit, and applies default store from access level when the user
 * has not selected any store.
 *
 * @param filters - Current filter values from the list view
 * @param accessLevelResponse - Options from getInitialFiltersByAccessLevel (e.g. store list)
 * @returns Query object with page, limit, and filters ready for buildSearchPayload
 */
export function buildSearchQuery(
    filters: IServiceClientFilterValues,
    accessLevelResponse: TFiltersOptions | null
): ServiceClientSearchQuery {
    const query: ServiceClientSearchQuery = {
        ...filters,
        page: (filters.page || 0) + 1,
        limit: filters.limit ?? 50,
    };
    if (!accessLevelResponse?.store?.length) return query;
    if (
        (query.store && query.store.length > 0) ||
        (Array.isArray(filters.store) && filters.store.length > 0)
    )
        return query;
    return { ...query, store: accessLevelResponse.store };
}
